<template>
  <div
    class="d-flex flex-column justify-content-between"
  >
    <b-card>
      <div
        class="d-flex flex-column align-items-center"
      >
        <b-card-title>
          <h3>
            Booking Number
          </h3>
        </b-card-title>
        <h4
          class="font-weight-bold trip_number_color"
        >
          {{ number }}
        </h4>

      </div>
    </b-card>
    <b-card>
      <div
        class="d-flex flex-column align-items-center"
      >
        <b-card-title>
          <h3>
            Booking State
          </h3>
        </b-card-title>
        <h4
          class="font-weight-bold trip_number_color"
        >
          <BookingBadge :state="state" />
        </h4>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardTitle } from 'bootstrap-vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import BookingBadge from './BookingBadge.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BookingBadge,
  },
  props: {
    state: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      snakeCaseToCamelCase,
    }
  },
}
</script>
